/* Cookie / KVKK consent bar.

   The visitor's answer is sent to Shopify's Customer Privacy API so that
   declining actually withholds consent from the analytics and marketing pixels
   — hiding the bar alone would not.

   The answer is also stored locally, together with whether it reached Shopify.
   An answer that could not be delivered (API blocked, slow CDN, ad-blocker) is
   kept as unsynced and retried on the next page load, so a decline is never
   silently lost. The stored answer is re-applied on every load anyway, which
   keeps localStorage and Shopify's own consent cookie from drifting apart. */
(function () {
  var KEY = 'bl-consent';
  var banner = document.querySelector('[data-bl-consent]');

  function stored() {
    var raw;
    try { raw = localStorage.getItem(KEY); } catch (e) { return null; }
    if (!raw) return null;
    // answers written by earlier versions are a bare 'granted' / 'denied'
    if (raw === 'granted' || raw === 'denied') return { value: raw, synced: true };
    try {
      var parsed = JSON.parse(raw);
      return parsed && parsed.value ? parsed : null;
    } catch (e) { return null; }
  }

  function remember(value, synced) {
    try { localStorage.setItem(KEY, JSON.stringify({ value: value, synced: !!synced })); } catch (e) { /* private mode */ }
  }

  function withPrivacyApi(fn) {
    if (window.Shopify && window.Shopify.customerPrivacy) return fn(window.Shopify.customerPrivacy);
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return fn(null);
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        var failed = Array.isArray(error) ? error.length > 0 : !!error;
        fn(failed || !window.Shopify.customerPrivacy ? null : window.Shopify.customerPrivacy);
      }
    );
  }

  /* Hands the answer to Shopify. onDone(true) only when it was accepted. */
  function apply(granted, onDone) {
    withPrivacyApi(function (api) {
      if (!api || typeof api.setTrackingConsent !== 'function') return onDone(false);
      try {
        api.setTrackingConsent(
          {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted
          },
          function (result) {
            onDone(!(result && result.error));
          }
        );
      } catch (e) { onDone(false); }
    });
  }

  var saved = stored();

  /* Re-assert whatever the visitor chose before; retries a delivery that failed. */
  if (saved) {
    apply(saved.value === 'granted', function (ok) {
      if (ok && !saved.synced) remember(saved.value, true);
    });
  }

  if (!banner) return;

  var root = document.documentElement;

  /* The product page pins its own buy bar to the bottom of the viewport. While
     this bar is open it would sit on top of it, so publish the bar height and
     let that buy bar move up by exactly as much. */
  function publishHeight() {
    root.style.setProperty('--bl-consent-h', banner.offsetHeight + 'px');
  }

  function show() {
    banner.hidden = false;
    banner.setAttribute('data-open', '');
    root.classList.add('bl-consent-open');
    publishHeight();
    if (window.ResizeObserver) new ResizeObserver(publishHeight).observe(banner);
    window.addEventListener('resize', publishHeight);
  }

  function hide() {
    banner.removeAttribute('data-open');
    banner.hidden = true;
    root.classList.remove('bl-consent-open');
    root.style.setProperty('--bl-consent-h', '0px');
  }

  function answer(granted) {
    var value = granted ? 'granted' : 'denied';
    hide();
    remember(value, false);
    apply(granted, function (ok) { remember(value, ok); });
  }

  var accept = banner.querySelector('[data-bl-consent-accept]');
  var decline = banner.querySelector('[data-bl-consent-decline]');
  if (accept) accept.addEventListener('click', function () { answer(true); });
  if (decline) decline.addEventListener('click', function () { answer(false); });

  if (!saved) show();
})();
